import React, { forwardRef } from 'react';
import { Tooltip } from '@contrast-security-inc/design-system-popovers';
import { IconButton } from '@contrast-security-inc/design-system-buttons';
import { css, cx } from '@emotion/css';
import { Stack } from '@contrast-security-inc/design-system-layouts';
import { Text } from '@contrast-security-inc/design-system-typography';
import { theme } from '@contrast-security-inc/design-system-foundations';
const actionCss = (disabled) => css `
  cursor: pointer;
  gap: 2px;
  ${!disabled
    ? `:focus-visible, :hover {
      span, button, svg {
        color: ${theme.color.neutral100};
        fill: ${theme.color.neutral100};
      }
    }`
    : `
      cursor: default;
      span {
        opacity: 0.3;
      }
    `}
`;
export const ActionButton = forwardRef(({ IconButtonProps, TooltipProps, metadata, onClick, className, isDisabled, 
// Popover Aria props should be passed to button
'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, 'aria-controls': ariaControls, ...rest }, ref) => {
    const tooltipAndButton = (React.createElement(Tooltip, { ...TooltipProps, enabled: TooltipProps.enabled !== false, size: "sm", ref: ref },
        React.createElement(IconButton, { isDisabled: isDisabled, ...(!metadata ? { onClick, className, ...rest } : {}), ...IconButtonProps, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, "aria-controls": ariaControls })));
    return metadata ? (React.createElement(Stack, { ...rest, className: cx(actionCss(!!isDisabled), className, 'ds-action-button'), 
        // if there's metadata pass the interactive props to the Stack
        onClick: !isDisabled ? onClick : undefined, alignItems: "center", ref: ref },
        metadata && (React.createElement(Text, { font: "metadata", color: "neutral80" }, metadata)),
        tooltipAndButton)) : (tooltipAndButton);
});
ActionButton.displayName = 'ActionButton';
